import qs from "qs";
import {
  ConferenceProjectListPresenter,
  ConferenceProjectTitleListPresenter
} from '../../../components/other-web/Conference/Presenters/ConferenceProjectListPresenter';
import {
  ConferenceProjectPresenter
} from '../../../components/other-web/Conference/Presenters/ConferenceProjectPresenter';
import {
  ConferenceSearchPerDate
} from '../../../components/other-web/Conference/Presenters/ConferenceSearchPerDate';
import {
  ConferenceBookingDetailPresenter
} from '../../../components/other-web/Conference/Presenters/ConferenceBookingDetailPresenter';

import { staticProjectIdsSC } from '../../../components/other-web/Conference/Presenters/Static';

export class ConferenceClient {
  /**
   *
   * @param {import('./HTTPClient').HTTPClient} httpClient
   * @param {string} baseURL
   */
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/conference`;
  }

  async getConferenceProjectList(projectId, query) {
    const resolvedProjectId = projectId ?? staticProjectIdsSC;
    const queryParams = qs.stringify(query, { addQueryPrefix: true });

    const url = `${this.baseURL}/project/${resolvedProjectId}/rooms${queryParams}`;

    const response = await this.httpClient.request("get", url);

    const conferenceProjectList = response.data.result

    if (query && query.titleonly) {
      return conferenceProjectList.map(
        item => new ConferenceProjectTitleListPresenter(item)
      )
    } 
      return conferenceProjectList.map(
        item => new ConferenceProjectListPresenter(item)
      )
    
  }

  async getConferenceById(conferenceId) {
    const url = `${this.baseURL}/room/${conferenceId}`;

    const response = await this.httpClient.request("get", url);

    const conferenceProjectById = response.data.result

    return new ConferenceProjectPresenter(conferenceProjectById)
  }

  async postMakeBooking(data) {
    const url = `${this.baseURL}/book`;

    const response = await this.httpClient.request("post", url, {
      data
    });

    return response.data.result;
  }

  async getConferenceSearchList(paramsQuery) {
    const queryParams = qs.stringify(paramsQuery, { addQueryPrefix: true });

    const url = `${this.baseURL}/find${queryParams}`;

    const response = await this.httpClient.request("get", url);

    const conferenceProjectListByDateQuery = response.data.result

    return conferenceProjectListByDateQuery.map(
      item => new ConferenceSearchPerDate(item)
    )
  }

  async getConferenceBookingDetail(bookingId, presenterType) {
    const url = `${this.baseURL}/book/${bookingId}`;

    const response = await this.httpClient.request("get", url);

    const bookingDetail = response.data.result

    switch (presenterType) {
      case "customer":
        return new ConferenceBookingDetailPresenter(bookingDetail)
      default:
        return bookingDetail
    }
  }

  async getBooks(query) {
    const queryParams = qs.stringify(query, { addQueryPrefix: true, skipNulls: true });

    const url = `${this.baseURL}/books${queryParams}`;

    const response = await this.httpClient.request("get", url);

    return response.data.result
  }

  async putConferenceByBookingId(bookingNumber, params) {
    const url = `${this.baseURL}/book/${bookingNumber}`;

    const response = await this.httpClient.request("put", url, {
      data: params
    });

    return response.data.result;
  }

  async getUserBooks(query) {
    const queryParams = qs.stringify(query, { addQueryPrefix: true, skipNulls: true });

    const url = `${this.baseURL}/user_books${queryParams}`;

    const response = await this.httpClient.request("get", url);

    return response.data.result
  }
}